module.exports = __webpack_public_path__ + "img/Rectangle_9944@2x.45274479.png";